import "./tile.css";

const Tile = ({letter, points, scale, bottom, position, onClick, onMouseDown, onMouseUp, style}) => {
    const BASE_SCALE = 75;
    const tileType = "red";
    return (
        <div  className={`tile ${tileType} ${points ? "" : "blank"}`} 
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
        style={{
            ...style,
            margin: scale / BASE_SCALE,
            width: `${scale - (scale / BASE_SCALE)}px`, 
            height: `${scale - (scale / BASE_SCALE)}px`,
            lineHeight: `${65 * scale / BASE_SCALE}px`,    
            borderWidth: `${2 * scale / BASE_SCALE}px`,
            borderRadius: `${3 * scale / BASE_SCALE}px`,
            fontSize: `${55 * scale / BASE_SCALE}px`,
            bottom: `${bottom * scale / BASE_SCALE}px`,
            left: `${position * scale / BASE_SCALE}px`
        }} >
            {letter}<div 
                className="points"
                style={{
                    fontSize: `${15 * scale / BASE_SCALE}px`,
                    lineHeight: `${15 * scale / BASE_SCALE}px`,
                    bottom: `${7 * scale / BASE_SCALE}px`,
                    right: `${4 * scale / BASE_SCALE}px`
                }}
            >{points || ""}</div>
        </div>
    )
}

export default Tile;